var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"id":"logo","src":_vm.logo[_vm.position],"alt":"Jugem's Cloud Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }